var translations = {};
function getTranslation(key) {
  return translations[key]?.[Shopify.locale] || translations[key]?.en || key;
}

let __lastVariantIdProcessed = null;
let __lastValidInventoryLocations = null;

/**
 * Venter på at et element dukker op i DOM’en.
 * @param {string} selector - CSS-selector for elementet.
 * @param {number} interval - Hvor ofte (ms) vi tjekker.
 * @param {number} timeout - Maks tid (ms) vi venter før fiasko.
 * @returns {Promise<Element>}
 */
function waitForElement(selector, interval = 100, timeout = 5000) {
  return new Promise((resolve, reject) => {
    const start = Date.now();

    const checker = setInterval(() => {
      const el = document.querySelector(selector);
      if (el) {
        clearInterval(checker);
        resolve(el);
      } else if (Date.now() - start > timeout) {
        clearInterval(checker);
        reject(new Error(`Element "${selector}" ikke fundet indenfor ${timeout}ms`));
      }
    }, interval);
  });
}
document.addEventListener("DOMContentLoaded", function() {
  const stockTranslationsUrl = window.STOCK_TRANSLATIONS_URL;
  fetch(stockTranslationsUrl)
    .then(r => r.json())
    .then(data => { translations = data; init(); })
    .catch(err => console.error('Translations fetch error:', err));
});
async function fetchCartTotalPrice() {
  try {
    const response = await fetch('/cart.js');
    if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
    
    const cart = await response.json();
    return cart.total_price ? cart.total_price / 100 : 0;
  } catch (error) {
    console.error('Error fetching cart data:', error);
    return null;
  }
}
function replaceStockClass(selector, newClass) {
  if (selector) {
    selector.classList.forEach(className => {
      if (className.startsWith('product-stock-information-child--stock_indicator__') || className.startsWith('product-stock-information-child--stock_label__')) {
        selector.classList.remove(className);
      }
    });
    selector.classList.add(newClass);
  }
}
function getVariantDataAttribute(variantIdentifier, dataAttribute) {
  const variantOption = document.querySelector(`option[data-variant-id="${variantIdentifier}"], input[data-variant-id="${variantIdentifier}"]`);
  return variantOption?.getAttribute(dataAttribute) || false;
}
function getVariantInventoryQuantity(variantIdentifier) {
  const variantOption = document.querySelector(`option[data-variant-id="${variantIdentifier}"], input[data-variant-id="${variantIdentifier}"]`);
  
  if (variantOption) {
    const quantityString = variantOption.getAttribute('data-variant-inventory-quantity');
    
    return quantityString !== null ? parseInt(quantityString, 10) : false;
  }

  const liquidFallbackQuantity = '';

  return liquidFallbackQuantity !== null ? parseInt(liquidFallbackQuantity, 10) : false;
}
function getLocations(productType, identifier) {
  console.log('DEBUG getLocations called with productType:', productType, 'identifier:', identifier);
  
  // Hvis identifier er 'select_a_variant', prøv at finde den aktuelle valgte variant
  if (identifier === 'select_a_variant' && productType === 'variant') {
    console.log('DEBUG handling select_a_variant case');
    const selectedVariantElement = document.querySelector('input[name="id"]:checked, select[name="id"] option:checked, input[name="id"][checked]');
    if (selectedVariantElement) {
      const actualVariantId = selectedVariantElement.value || selectedVariantElement.getAttribute('value');
      console.log('DEBUG found actual variant ID:', actualVariantId);
      identifier = actualVariantId;
    } else {
      console.log('DEBUG no selected variant found, checking URL');
      const urlVariantId = getCurrentVariantId();
      if (urlVariantId) {
        identifier = urlVariantId;
        console.log('DEBUG using URL variant ID:', identifier);
      }
    }
  }
  
  if (productType === 'variant') {
    const variantOption = document.querySelector(
      `option[data-variant-id="${identifier}"], input[data-variant-id="${identifier}"]`
    );
    const variantLocations = variantOption?.getAttribute('data-variant-locations') || '';
    console.log('DEBUG getLocations variant - selector:', `option[data-variant-id="${identifier}"], input[data-variant-id="${identifier}"]`);
    console.log('DEBUG getLocations variant - variantOption found:', !!variantOption);
    console.log('DEBUG getLocations variant - variantLocations:', variantLocations);
    return variantLocations;
  } else if (['single-product', 'variant-single-option'].includes(productType)) {
    const wrapper = document.querySelector('.product-stock-information-wrapper');
    let inventoryLocations = wrapper?.getAttribute('data-inventory-locations') || '';
    
    console.log('DEBUG getLocations single-product/variant-single-option - data-inventory-locations:', inventoryLocations);
    
    // Fallback: hvis inventory-locations er tom, prøv custom.locations fra den valgte variant
    if (!inventoryLocations || inventoryLocations.trim() === '') {
      const selectedVariantElement = document.querySelector('input[name="id"]:checked, select[name="id"] option:checked');
      console.log('DEBUG fallback - selectedVariantElement found:', !!selectedVariantElement);
      if (selectedVariantElement) {
        const variantId = selectedVariantElement.value || selectedVariantElement.getAttribute('value');
        console.log('DEBUG fallback - variantId:', variantId);
        const variantOption = document.querySelector(`input[data-variant-id="${variantId}"], option[data-variant-id="${variantId}"]`);
        console.log('DEBUG fallback - variantOption found:', !!variantOption);
        const customLocations = variantOption?.getAttribute('data-variant-locations') || '';
        console.log('DEBUG fallback to custom locations - customLocations:', customLocations);
        inventoryLocations = customLocations;
      }
    }
    
    console.log('DEBUG final locations result:', inventoryLocations);
    return inventoryLocations;
  }
  return '';
}
function getFormattedDate(dateString) {
  return new Intl.DateTimeFormat('da-DK', { day: 'numeric', month: 'long', year: 'numeric' }).format(new Date(dateString));
}
function handleHiddenOrderInputPreorderDate(identifier) {
  $('.shopify-product-form input[name="properties[Forudbestilling - Afsendelsesdato]"]').remove();
  const preorderDate = getVariantDataAttribute(identifier, 'data-variant-preorder-date');
  if (preorderDate) {
    const preorderShippingDate = new Date(preorderDate).toLocaleDateString('da-DK', { day: '2-digit', month: '2-digit', year: 'numeric' });
    $(`<input type="hidden" name="properties[Forudbestilling - Afsendelsesdato]" value="${preorderShippingDate}">`).insertBefore('.shopify-product-form .purchase-details__buttons');
  }
}
function hasStockInLocations(inventoryLocations = [], locations) {
  const inventoryArray = inventoryLocations.split(',').map(location => location.trim().toLowerCase());
  const normalizedLocations = locations.map(location => location.toLowerCase());
  return normalizedLocations.some(location => inventoryArray.includes(location));
}
function handleHiddenOrderInputField(identifier, type, text) {
  console.log('type: ' + type);
  console.log('text: ' + text);
  if (type == 'delivery') {
    var elementDeliveryProperty = $('.shopify-product-form #custom--product-property__delivery');
    if (elementDeliveryProperty.length) {
      console.log('Stock information.js loaded under delivery');
      if (text) {
        elementDeliveryProperty.val(text);
      } else {
        elementDeliveryProperty.val("N/A");
      }
    }
  } else if (type == 'pickupFrederiksberg') {
    var elementPickupFrederiksbergProperty = $('.shopify-product-form #custom--product-property__pickup-frederiksberg');
    if (elementPickupFrederiksbergProperty.length) {
      if (text) {
        elementPickupFrederiksbergProperty.val(text);
      } else {
        elementPickupFrederiksbergProperty.val("N/A");
      }
    }
  } else if (type == 'pickupAarhus') {
    var elementPickupAarhusProperty = $('.shopify-product-form #custom--product-property__pickup-aarhus');
    if (elementPickupAarhusProperty.length) {
      if (text) {
        elementPickupAarhusProperty.val(text);
      } else {
        elementPickupAarhusProperty.val("N/A");
      }
    }
  }
}
function updateCurrentDeliveryInformation(inventoryLocations = [], identifier, productType) {
  const deliveryElement = document.querySelector('.product-stock-information--delivery');
  const deliveryStockIndicator = deliveryElement.querySelector('.product-stock-information-child--stock_indicator');
  const deliveryStockStatus = deliveryElement.querySelector('#product-stock-information--delivery-stock-status');
  const deliveryTime = deliveryElement.querySelector('#product-stock-information--delivery-time');
  const deliveryLabel = deliveryElement.querySelector('.product-stock-information--delivery-label');

  deliveryElement.style.display = 'inline-flex';
  deliveryStockIndicator.style.display = 'inline-flex';
  deliveryStockStatus.style.display = 'inline-flex';
  deliveryLabel.textContent = getTranslation('delivery');
  deliveryStockStatus.style.fontWeight = '400';

  const setStockStatus = (indicatorClass, statusClass, statusText, timeText, fontWeight = '400') => {
    replaceStockClass(deliveryStockIndicator, indicatorClass);
    replaceStockClass(deliveryStockStatus, statusClass);
    deliveryStockStatus.textContent = statusText;
    deliveryTime.innerHTML = timeText;
    deliveryStockStatus.style.fontWeight = fontWeight;
    handleHiddenOrderInputField(identifier, 'delivery', timeText);
  
    const observer = new MutationObserver(() => {
      if (!deliveryTime.textContent || deliveryTime.textContent.trim() === '') {
        deliveryTime.innerHTML = timeText;
      }
    });
    
    observer.observe(deliveryTime, { childList: true, subtree: true });
  };
  
  // Check for single-product eller variant uden locations men stadig available
  if (!inventoryLocations || inventoryLocations === '') {
    // Tjek om produktet faktisk har inventory management men bare mangler locations
    const hasInventoryManagement = getVariantDataAttribute(identifier, 'data-variant-inventory-management');
    const isAvailable = getVariantDataAttribute(identifier, 'data-variant-available') === 'true';
    
    // Hvis produktet er available men bare mangler locations, behandl som inventory_not_managed
    if (!hasInventoryManagement || isAvailable) {
      setStockStatus('product-stock-information-child--stock_indicator__in-stock', 'product-stock-information-child--stock_label__in-stock', getTranslation('in_stock'), getTranslation('ships_within_0_1_weekday'));
      return;
    }
    
    // Ellers er det faktisk out of stock
    setStockStatus('product-stock-information-child--stock_indicator__out-of-stock', 
                  'product-stock-information-child--stock_label__out-of-stock', 
                  getTranslation('out_of_stock'), 
                  getTranslation('unavailable'));
    return;
  }
  
  if (inventoryLocations === 'out_of_stock') {
    setStockStatus('product-stock-information-child--stock_indicator__out-of-stock', 
                  'product-stock-information-child--stock_label__out-of-stock', 
                  getTranslation('out_of_stock'), 
                  getTranslation('unavailable'));
    return;
  }
  
  const locationsToCheck = ['spinchy frederiksberg', 'spinchy aarhus', 'spinchy århus', 'spinchy åarhus', 'tmc', 'il caffettiere'];
  var setStockStatusFromLocations = false;
  
  const inventoryArray = inventoryLocations.split(',').map(loc => loc.trim().toLowerCase());
  const hasStockInFrederiksberg = inventoryArray.includes('spinchy frederiksberg');
  // Check all possible Aarhus variations for delivery too
  const hasStockInAarhus = inventoryArray.includes('spinchy aarhus') || 
                           inventoryArray.includes('spinchy århus') || 
                           inventoryArray.includes('spinchy åarhus') ||
                           inventoryArray.some(loc => loc.includes('spinchy') && (loc.includes('aarhus') || loc.includes('århus') || loc.includes('åarhus')));
  
  const hasStockInAny = hasStockInLocations(inventoryLocations, locationsToCheck);

  const isOrderOnDemand = !!getVariantDataAttribute(identifier, 'data-variant-order-on-demand');
  const isPreorder = !!getVariantDataAttribute(identifier, 'data-variant-preorder-date');
  const isAvailable = getVariantDataAttribute(identifier, 'data-variant-available') === 'true';
  
  /* Check for bundle med inventory_not_managed */
  if (identifier === 'bundle' && inventoryLocations === 'inventory_not_managed') {
    setStockStatus('product-stock-information-child--stock_indicator__in-stock', 'product-stock-information-child--stock_label__in-stock', getTranslation('in_stock'), getTranslation('ships_within_0_1_weekday'));
    return;
  }
  
  setStockStatusFromLocations = (!isOrderOnDemand && !isPreorder) && (isAvailable || productType === 'single-product' || identifier === 'bundle');
  
  if (setStockStatusFromLocations) {
    if (hasStockInFrederiksberg) {
      setStockStatus('product-stock-information-child--stock_indicator__in-stock', 'product-stock-information-child--stock_label__in-stock', getTranslation('in_stock'), getTranslation('ships_within_0_1_weekday'));
    } else if (hasStockInAny) {
      setStockStatus('product-stock-information-child--stock_indicator__in-stock-far-away', 'product-stock-information-child--stock_label__in-stock-far-away', getTranslation('in_stock_far_away'), getTranslation('ships_within_2_5_weekdays'));
    } else {
      setStockStatus('product-stock-information-child--stock_indicator__out-of-stock', 'product-stock-information-child--stock_label__out-of-stock', getTranslation('out_of_stock'), getTranslation('unavailable'));
    }
  }  

  

  // console.log('inventoryLocations:', inventoryLocations);
// console.log('hasStockInFrederiksberg:', hasStockInFrederiksberg);
// console.log('hasStockInAny:', hasStockInAny);
// console.log('isOrderOnDemand:', isOrderOnDemand);
// console.log('isPreorder:', isPreorder);
// console.log('identifier:', identifier);
// console.log('setStockStatusFromLocations:', setStockStatusFromLocations);

  if (productType === 'variant' || productType === 'variant-single-option') {
    /* Handle on variant preorder */
    if (getVariantDataAttribute(identifier, 'data-variant-preorder-date')) {
      if (getVariantInventoryQuantity(identifier) <= 0) {
        setStockStatus('product-stock-information-child--stock_indicator__out-of-stock', 'product-stock-information-child--stock_label__out-of-stock', getTranslation('out_of_stock'), getTranslation('unavailable'));
      }
      
      const preorderDate = getVariantDataAttribute(identifier, 'data-variant-preorder-date');
      if (preorderDate) {
        setStockStatus('product-stock-information-child--stock_indicator__in-stock-far-away', 'product-stock-information-child--stock_label__in-stock-far-away', getTranslation('preorder'), getTranslation('order_now_ships_on') + ' ' + getFormattedDate(preorderDate));
      }
      handleHiddenOrderInputPreorderDate(identifier);
    /* Handle on variant order on demand */
    } else if( getVariantDataAttribute(identifier, 'data-variant-order-on-demand') ) {
      const orderOnDemandTextDK = getVariantDataAttribute(identifier, 'data-variant-order-on-demand-text-dk').trim();
      const orderOnDemandTextEN = getVariantDataAttribute(identifier, 'data-variant-order-on-demand-text-en').trim();
      const wrapInSpan = (text) => {
        return `<span class="product-stock-information--delivery-time-val">${text}</span>`;
      };
      if (Shopify.locale == 'da' && orderOnDemandTextDK) {
        setStockStatus('product-stock-information-child--stock_indicator__in-stock-far-away', 'product-stock-information-child--stock_label__in-stock-far-away', getTranslation('order_on_demand'), getTranslation('order_now_order_on_demand') + wrapInSpan(orderOnDemandTextDK));
      } else if (Shopify.locale == 'en' && orderOnDemandTextEN) {
        setStockStatus('product-stock-information-child--stock_indicator__in-stock-far-away', 'product-stock-information-child--stock_label__in-stock-far-away', getTranslation('order_on_demand'), getTranslation('order_now_order_on_demand') + wrapInSpan(orderOnDemandTextEN));
      }
    } else if (getVariantDataAttribute(identifier, 'data-variant-available') !== 'true'
              && getVariantDataAttribute(identifier, 'data-variant-inventory-management')) {
      setStockStatus('product-stock-information-child--stock_indicator__out-of-stock', 'product-stock-information-child--stock_label__out-of-stock', getTranslation('out_of_stock'), getTranslation('unavailable'));
    } else if (!getVariantDataAttribute(identifier, 'data-variant-inventory-management')) {
      inventoryLocations = 'inventory_not_managed';
    }
  }

  if (inventoryLocations === 'select_a_variant') {
    deliveryStockStatus.innerHTML = getTranslation('select_a_variant');
    deliveryTime.innerHTML = getTranslation('select_a_variant');
    return;
  }

  if (inventoryLocations === 'inventory_not_managed') {
    // console.log('delivery inventoryLocations: ' +inventoryLocations);
    setStockStatus('product-stock-information-child--stock_indicator__in-stock', 'product-stock-information-child--stock_label__in-stock', getTranslation('in_stock'), getTranslation('ships_within_0_1_weekday'));
    return;
  }
}

function updateCurrentPickupInformation(inventoryLocations = [], identifier) {
  console.log('DEBUG updateCurrentPickupInformation - inventoryLocations:', inventoryLocations);
  console.log('DEBUG updateCurrentPickupInformation - identifier:', identifier);
  
  if (!document.querySelector('.product-stock-information--pickup')) return;
  const pickupElement = document.querySelector('.product-stock-information--pickup');
  const pickupStockIndicator = pickupElement.querySelector('.product-stock-information-child--stock_indicator');
  const pickupClickAndCollect = pickupElement.querySelector('#product-stock-information--pickup-click-and-collect');
  const pickupFrederiksberg = pickupElement.querySelector('#product-stock-information--pickup-frederiksberg');
  const pickupAarhus = pickupElement.querySelector('#product-stock-information--pickup-aarhus');
  const pickupHammerholmen = pickupElement.querySelector('#product-stock-information--pickup-hammerholmen');
  const pickupAmager = pickupElement.querySelector('#product-stock-information--pickup-amager');

  pickupElement.style.display = 'inline-flex';

  const setPickupStatus = (indicatorClass, statusClass, frederiksbergText, aarhusText, hammerholmenText, amagerText, location = 'all') => {
    replaceStockClass(pickupStockIndicator, indicatorClass);
    replaceStockClass(pickupClickAndCollect, statusClass);
    
    if (location === 'frederiksberg' || location === 'all') {
      setStoreNameText(pickupFrederiksberg, frederiksbergText, 'frederiksberg');
      handleHiddenOrderInputField(identifier, 'pickupFrederiksberg', frederiksbergText);
    }
    if (location === 'aarhus' || location === 'all') {
      setStoreNameText(pickupAarhus, aarhusText, 'aarhus');
      handleHiddenOrderInputField(identifier, 'pickupAarhus', aarhusText);
    }
    if (location === 'hammerholmen' || location === 'all') {
      if (pickupHammerholmen) {
        setStoreNameText(pickupHammerholmen, hammerholmenText || getTranslation('0_5_weekdays'), 'hammerholmen');
      }
    }
    if (location === 'amager' || location === 'all') {
      if (pickupAmager) {
        setStoreNameText(pickupAmager, amagerText || getTranslation('0_5_weekdays'), 'amager');
      }
    }
  };

  // Helper function to set store name text and make the whole line clickable
  function setStoreNameText(element, text, storeId) {
    if (!element) return;
    
    // Set the text content
    element.textContent = text;
    
    // Find the parent <p> element with store-pickup-line class
    const parentLine = element.closest('.store-pickup-line');
    if (!parentLine) return;
    
    // Only make clickable if text is available (not unavailable or select_a_variant)
    if (text && text !== getTranslation('unavailable') && text !== getTranslation('select_a_variant')) {
      parentLine.classList.add('store-pickup-line--clickable');
      parentLine.setAttribute('data-store-id', storeId);
    } else {
      parentLine.classList.remove('store-pickup-line--clickable');
      parentLine.removeAttribute('data-store-id');
    }
  }
    // console.log('Identifier:', identifier);

  // Special håndtering for bundles baseret på inventory locations
  if (identifier === 'bundle') {
    // Hvis bundle ikke har inventory management
    if (inventoryLocations === 'inventory_not_managed') {
      setPickupStatus(
        'product-stock-information-child--stock_indicator__in-stock',
        'product-stock-information-child--stock_label__in-stock',
        getTranslation('0_5_weekdays'),
        getTranslation('0_5_weekdays'),
        getTranslation('0_5_weekdays'),
        getTranslation('0_5_weekdays')
      );
      return;
    }
    
    const locationsArray = inventoryLocations
      ? inventoryLocations.split(',').map(loc => loc.trim().toLowerCase())
      : [];

    // console.log('Bundle inventory locations:', inventoryLocations);

    const hasFrederiksberg = locationsArray.includes('spinchy frederiksberg');
    const hasAarhus = locationsArray.includes('spinchy aarhus') || 
                      locationsArray.includes('spinchy århus') || 
                      locationsArray.includes('spinchy åarhus') ||
                      locationsArray.some(loc => loc.includes('spinchy') && (loc.includes('aarhus') || loc.includes('århus') || loc.includes('åarhus')));

    const hasHammerholmen = locationsArray.includes('hammerholmen');
    const hasAmager = locationsArray.includes('amager');
    
    if (hasFrederiksberg || hasAarhus || hasHammerholmen || hasAmager) {
      setPickupStatus(
        'product-stock-information-child--stock_indicator__in-stock',
        'product-stock-information-child--stock_label__in-stock',
        hasFrederiksberg ? getTranslation('0_1_weekday') : getTranslation('unavailable'),
        hasAarhus ? getTranslation('0_1_weekday') : getTranslation('unavailable'),
        hasHammerholmen ? getTranslation('0_5_weekdays') : getTranslation('unavailable'),
        hasAmager ? getTranslation('0_5_weekdays') : getTranslation('unavailable')
      );
    } else {
      setPickupStatus(
        'product-stock-information-child--stock_indicator__out-of-stock',
        'product-stock-information-child--stock_label__out-of-stock',
        getTranslation('unavailable'),
        getTranslation('unavailable'),
        getTranslation('unavailable'),
        getTranslation('unavailable')
      );
    }
    return;
  }

  // Hvis inventoryLocations er tom/undefined men produktet er available, behandl som inventory_not_managed
  if ((!inventoryLocations || inventoryLocations === '') && identifier !== 'bundle') {
    const hasInventoryManagement = getVariantDataAttribute(identifier, 'data-variant-inventory-management');
    const isAvailable = getVariantDataAttribute(identifier, 'data-variant-available') === 'true';
    
    // Hvis produktet er available eller ikke har inventory management, vis pickup som tilgængelig
    if (!hasInventoryManagement || isAvailable) {
      setPickupStatus(
        'product-stock-information-child--stock_indicator__in-stock',
        'product-stock-information-child--stock_label__in-stock',
        getTranslation('0_5_weekdays'),
        getTranslation('0_5_weekdays'),
        getTranslation('0_5_weekdays'),
        getTranslation('0_5_weekdays')
      );
      return;
    }
  }

  // Pickup: prioritize location-based availability when we have location data
  const pickupAttr = getVariantDataAttribute(identifier, 'data-variant-pickup-available');
  const hasLocationData = !!(inventoryLocations && inventoryLocations !== 'unavailable' && inventoryLocations !== 'select_a_variant');
  
  // If we have location data, use location-based logic; otherwise fall back to pickup attribute
  const isPickupAvailable = hasLocationData 
    ? true  // If we have locations, pickup is potentially available 
    : (pickupAttr != null ? (pickupAttr === 'true') : false);

  console.log('DEBUG pickup pickupAttr:', pickupAttr);
  console.log('DEBUG pickup hasLocationData:', hasLocationData);
  console.log('DEBUG pickup isPickupAvailable:', isPickupAvailable);
  console.log('DEBUG pickup inventoryLocations check:', inventoryLocations, inventoryLocations !== 'unavailable', inventoryLocations !== 'select_a_variant');

  if (!isPickupAvailable && identifier !== 'inventory_not_managed') {
    console.log('DEBUG pickup - setting unavailable because isPickupAvailable is false');
    setPickupStatus(
      'product-stock-information-child--stock_indicator__out-of-stock',
      'product-stock-information-child--stock_label__out-of-stock',
      getTranslation('unavailable'),
      getTranslation('unavailable'),
      getTranslation('unavailable'),
      getTranslation('unavailable')
    );
    return;
  }

  if (inventoryLocations === 'select_a_variant') {
    setPickupStatus('', '', getTranslation('select_a_variant'), getTranslation('select_a_variant'), getTranslation('select_a_variant'), getTranslation('select_a_variant'));
    return;
  }

  if (inventoryLocations === 'inventory_not_managed') {
    setPickupStatus(
      'product-stock-information-child--stock_indicator__in-stock',
      'product-stock-information-child--stock_label__in-stock',
      getTranslation('0_5_weekdays'),
      getTranslation('0_5_weekdays'),
      getTranslation('0_5_weekdays'),
      getTranslation('0_5_weekdays')
    );
    return;
  }

  const inventoryArray = inventoryLocations.split(',').map(loc => loc.trim().toLowerCase());
  console.log('DEBUG pickup inventoryArray:', inventoryArray);
  console.log('DEBUG pickup inventoryArray exact strings:', inventoryArray.map(loc => `"${loc}"`));
  const hasStockInFrederiksberg = inventoryArray.includes('spinchy frederiksberg');
  // Check all possible Aarhus variations including the exact one from user's data
  const hasStockInAarhus = inventoryArray.includes('spinchy aarhus') || 
                           inventoryArray.includes('spinchy århus') || 
                           inventoryArray.includes('spinchy åarhus') ||
                           inventoryArray.some(loc => loc.includes('spinchy') && (loc.includes('aarhus') || loc.includes('århus') || loc.includes('åarhus')));
  const hasStockInHammerholmen = inventoryArray.includes('hammerholmen');
  const hasStockInAmager = inventoryArray.includes('amager');
  console.log('DEBUG pickup hasStockInFrederiksberg:', hasStockInFrederiksberg, 'hasStockInAarhus:', hasStockInAarhus, 'hasStockInHammerholmen:', hasStockInHammerholmen, 'hasStockInAmager:', hasStockInAmager);
  const locationsToCheck = ['spinchy frederiksberg', 'spinchy aarhus', 'spinchy århus', 'spinchy åarhus', 'tmc', 'il caffettiere', 'hammerholmen', 'amager'];
  const hasStockInAny = hasStockInLocations(inventoryLocations, locationsToCheck);

  if (getVariantDataAttribute(identifier, 'data-variant-order-on-demand')) {
    const orderOnDemandTextCandCForFrederiksbergDK = getVariantDataAttribute(identifier, 'data-variant-order-on-demand-text-c-and-c-for-frederiksberg-dk');
    const orderOnDemandTextCandCForFrederiksbergEN = getVariantDataAttribute(identifier, 'data-variant-order-on-demand-text-c-and-c-for-frederiksberg-en');
    const orderOnDemandTextCandCForAarhusDK = getVariantDataAttribute(identifier, 'data-variant-order-on-demand-text-c-and-c-for-aarhus-dk');
    const orderOnDemandTextCandCForAarhusEN = getVariantDataAttribute(identifier, 'data-variant-order-on-demand-text-c-and-c-for-aarhus-en');

    if (Shopify.locale == 'da') {
      if (orderOnDemandTextCandCForFrederiksbergDK) {
        setPickupStatus(
          'product-stock-information-child--stock_indicator__in-stock-far-away',
          'product-stock-information-child--stock_label__in-stock-far-away',
          orderOnDemandTextCandCForFrederiksbergDK,
          'none',
          'none',
          'none',
          'frederiksberg'
        );
      }
      if (orderOnDemandTextCandCForAarhusDK) {
        setPickupStatus(
          'product-stock-information-child--stock_indicator__in-stock-far-away',
          'product-stock-information-child--stock_label__in-stock-far-away',
          'none',
          orderOnDemandTextCandCForAarhusDK,
          'none',
          'none',
          'aarhus'
        );
      }
    } else if (Shopify.locale == 'en') {
      if (orderOnDemandTextCandCForFrederiksbergEN) {
        setPickupStatus(
          'product-stock-information-child--stock_indicator__in-stock-far-away',
          'product-stock-information-child--stock_label__in-stock-far-away',
          orderOnDemandTextCandCForFrederiksbergEN,
          'none',
          'none',
          'none',
          'frederiksberg'
        );
      }
      if (orderOnDemandTextCandCForAarhusEN) {
        setPickupStatus(
          'product-stock-information-child--stock_indicator__in-stock-far-away',
          'product-stock-information-child--stock_label__in-stock-far-away',
          'none',
          orderOnDemandTextCandCForAarhusEN,
          'none',
          'none',
          'aarhus'
        );
      }
    }
    return;
  }

  // Default opførsel for normale produkter
  if (isPickupAvailable) {
    const frederiksbergText = hasStockInFrederiksberg
      ? getTranslation('0_1_weekday')
      : hasStockInAny
        ? getTranslation('2_5_weekdays')
        : getTranslation('unavailable');
  
    const aarhusText = hasStockInAarhus
      ? getTranslation('0_1_weekday')
      : hasStockInAny
        ? getTranslation('3_7_weekdays')
        : getTranslation('unavailable');
  
    const hammerholmenText = hasStockInHammerholmen
      ? getTranslation('0_5_weekdays')
      : getTranslation('unavailable');
  
    const amagerText = hasStockInAmager
      ? getTranslation('0_5_weekdays')
      : getTranslation('unavailable');
  
    const indicatorClass = (hasStockInFrederiksberg || hasStockInAarhus || hasStockInHammerholmen || hasStockInAmager || hasStockInAny)
      ? 'product-stock-information-child--stock_indicator__in-stock'
      : 'product-stock-information-child--stock_indicator__out-of-stock';
  
    const statusClass = (hasStockInFrederiksberg || hasStockInAarhus || hasStockInHammerholmen || hasStockInAmager || hasStockInAny)
      ? 'product-stock-information-child--stock_label__in-stock'
      : 'product-stock-information-child--stock_label__out-of-stock';
  
    setPickupStatus(
      indicatorClass,
      statusClass,
      frederiksbergText,
      aarhusText,
      hammerholmenText,
      amagerText
    );
  } else {
    setPickupStatus(
      hasStockInAny ? 'product-stock-information-child--stock_indicator__in-stock' : 'product-stock-information-child--stock_indicator__out-of-stock',
      hasStockInAny ? 'product-stock-information-child--stock_label__in-stock' : 'product-stock-information-child--stock_label__out-of-stock',
      hasStockInFrederiksberg ? getTranslation('0_1_weekday') : getTranslation('unavailable'),
      hasStockInAarhus ? getTranslation('0_1_weekday') : getTranslation('unavailable'),
      hasStockInHammerholmen ? getTranslation('0_5_weekdays') : getTranslation('unavailable'),
      hasStockInAmager ? getTranslation('0_5_weekdays') : getTranslation('unavailable')
    );
  }
}


async function updateCurrentShippingInformation(variantIdentifier = false) {
  const shippingText = document.querySelector('.product-stock-information--shipping #product-stock-information--shipping-text');
  const variantPriceElement = document.querySelector('.product-stock-information-wrapper #product-stock-information--hidden-product_selected_variant_price');
  const wrapper = document.querySelector('.product-stock-information-wrapper');
  let variantPrice = isNaN(parseInt(variantPriceElement.value, 10)) ? 0 : parseInt(variantPriceElement.value, 10);
  let customVariantShippingPrice, customVariantShippingPriceInThousands;
  const cartTotalPrice = await fetchCartTotalPrice() * 100;
  
  // Get shipping prices from data attributes
  const shippingPriceDK = wrapper.getAttribute('data-shipping-price-dk') || 39;
  const shippingPriceSV = wrapper.getAttribute('data-shipping-price-sv') || 99;
  
  document.querySelector('.product-stock-information--shipping').style.display = 'inline-flex';

  if (variantIdentifier) {
    const variantOption = document.querySelector(`option[data-variant-id="${variantIdentifier}"]`) 
    || document.querySelector(`input[data-variant-id="${variantIdentifier}"]`);
    if (variantOption && variantOption.hasAttribute('data-variant-price')) {
      variantPrice = parseInt(variantOption.getAttribute('data-variant-price'), 10);
    }
    if (variantOption && variantOption.hasAttribute('data-variant-custom-shipping-price')) {
      customVariantShippingPrice = parseInt(variantOption.getAttribute('data-variant-custom-shipping-price'), 10);
    }
  }

  const locale = Shopify.locale;
  // Get the correct shipping price based on locale
  const baseShippingPrice = (locale === 'sv' || locale === 'sv-SE') ? shippingPriceSV : shippingPriceDK;
  
  if (locale === 'en') {
    shippingText.innerHTML = getTranslation('shipping_price_depends');
  } else if (customVariantShippingPrice) {
    shippingText.innerHTML = getTranslation('shipping_price').replace('{price}', customVariantShippingPrice);
  } else {
    // Determine free shipping threshold based on locale
    let freeShippingThreshold;
    if (locale === 'da' || locale === 'da-DK') {
      freeShippingThreshold = 50000; // 500 DKK in cents
    } else if (locale === 'sv' || locale === 'sv-SE') {
      freeShippingThreshold = 99900; // 999 SEK in cents
    } else {
      freeShippingThreshold = 49900; // Default threshold
    }
    if (variantPrice > freeShippingThreshold || cartTotalPrice > freeShippingThreshold) {
      shippingText.innerHTML = getTranslation('shipping_free');
    } else if (variantPrice === 'select_a_variant') {
      shippingText.innerHTML = getTranslation('select_a_variant');
    } else {
      if (customVariantShippingPrice) {
        shippingText.innerHTML = getTranslation('shipping_price').replace('{price}', customVariantShippingPrice);
      } else {
        shippingText.innerHTML = getTranslation('shipping_price').replace('{price}', baseShippingPrice);
      }
    }
  }
}
function updateInformation(productType, identifier = false) {
  console.log('DEBUG updateInformation - productType:', productType, 'identifier:', identifier);
  
  if (!identifier) return;
  if (__lastVariantIdProcessed === identifier) return; // ← VIGTIGT: stop dobbeltkald
  __lastVariantIdProcessed = identifier;

  // Debug: Se alle variant-elementer på siden
  const allVariantInputs = document.querySelectorAll('input[data-variant-id], option[data-variant-id]');
  console.log('DEBUG all variant elements found:', allVariantInputs.length);
  allVariantInputs.forEach((el, i) => {
    console.log(`DEBUG variant ${i}:`, el.getAttribute('data-variant-id'), 'has locations:', el.getAttribute('data-variant-locations'));
  });

  // 1) Læs "kan købes online" separat
  const hasInventoryManagement   = !!getVariantDataAttribute(identifier, 'data-variant-inventory-management');
  console.log('DEBUG hasInventoryManagement:', hasInventoryManagement);

  // 2) Find pickup-locations
  let inventoryLocations;
  if (identifier === 'inventory_not_managed') {
    inventoryLocations = 'inventory_not_managed';
  } else if (identifier === 'select_a_variant') {
    // Hvis vi får 'select_a_variant', prøv at finde den første tilgængelige variant med locations
    console.log('DEBUG: Handling select_a_variant, looking for first available variant');
    const allVariantOptions = document.querySelectorAll('input[data-variant-id], option[data-variant-id]');
    let foundLocations = 'select_a_variant';
    
    for (const variantOption of allVariantOptions) {
      const variantLocations = variantOption.getAttribute('data-variant-locations');
      if (variantLocations && variantLocations.trim()) {
        console.log('DEBUG: Found locations from variant:', variantOption.getAttribute('data-variant-id'), 'locations:', variantLocations);
        foundLocations = variantLocations;
        break; // Brug den første variant med locations
      }
    }
    
    inventoryLocations = foundLocations;
  } else {
    inventoryLocations = getLocations(productType, identifier);
  }

  // ✅ KRITISK FIX: beskyt mod varianter uden locations
  if (
    typeof inventoryLocations === 'string' &&
    inventoryLocations.trim() !== '' &&
    inventoryLocations !== 'select_a_variant' &&
    inventoryLocations !== 'unavailable' &&
    inventoryLocations !== 'inventory_not_managed'
  ) {
    // Gem sidste gyldige locations
    __lastValidInventoryLocations = inventoryLocations;
  } else if (__lastValidInventoryLocations) {
    console.log(
      'DEBUG fallback: variant without locations → reuse last valid locations',
      __lastValidInventoryLocations
    );
    inventoryLocations = __lastValidInventoryLocations;
  }

  console.log('DEBUG final inventoryLocations:', inventoryLocations);

  // 3) Hvis lager styres men locations er tomme → out_of_stock for delivery
  let deliveryLocations = inventoryLocations;
  if (hasInventoryManagement && (!inventoryLocations || inventoryLocations === 'unavailable')) {
    deliveryLocations = 'out_of_stock';
  }

  // 4) Opdater UI-sektioner
  updateCurrentPickupInformation(inventoryLocations, identifier);   // pickup baseret på locations
  updateCurrentShippingInformation(identifier);                     // fragt

  // 5) Vis wrapper og opdater delivery (adskilt fra pickup)
  const wrapperEl = document.querySelector('.product-stock-information-wrapper');
  if (wrapperEl) wrapperEl.style.display = 'flex';

  updateCurrentDeliveryInformation(deliveryLocations, identifier, productType);
}
function init() {
  const stockInformationWrapper = document.querySelector('.product-stock-information-wrapper');
  if (!stockInformationWrapper) return;

  if (stockInformationWrapper.hasAttribute("bundle-inventory-locations")) {
    updateCurrentDeliveryInformation(stockInformationWrapper.getAttribute("bundle-inventory-locations"), "bundle");
    updateCurrentPickupInformation(stockInformationWrapper.getAttribute("bundle-inventory-locations"), "bundle");
    updateCurrentShippingInformation();
    return;
  }

  let identifier;
  let productType;

  if (stockInformationWrapper.hasAttribute("data-single-product") && !stockInformationWrapper.hasAttribute("data-variant-product")) {
    productType = 'single-product';
  } else if (stockInformationWrapper.hasAttribute("data-variant-product")) {
    productType = 'variant';
  } else if (stockInformationWrapper.hasAttribute("data-variant-single-option-product")) {
    productType = 'variant-single-option';
  }

  const updateInfo = (type, id = false) => updateInformation(type, id);

  if (stockInformationWrapper.hasAttribute("data-inventory-management")) {
    if (productType === 'single-product') {
      // single product
      identifier = stockInformationWrapper.getAttribute("data-product-id");
      updateInfo('single-product', identifier);
    } else if (productType === 'variant') {
      // ← KONKRET: brug altid URL-varianten først
      identifier = getCurrentVariantId()
                || stockInformationWrapper.getAttribute("data-variant-id")
                || "select_a_variant";
      updateInfo('variant', identifier);
    } else {
      // variant-single-option (samme som variant)
      identifier = getCurrentVariantId()
                || stockInformationWrapper.getAttribute("data-variant-id")
                || "select_a_variant";
      updateInfo('variant-single-option', identifier);
    }
  } else {
    updateInfo(productType, 'inventory_not_managed');
  }
}

const getCurrentVariantId = () => new URLSearchParams(window.location.search).get('variant');

(async () => {
  try {
    const wrapper = await waitForElement('.product-stock-information-wrapper', 100, 10000);

    // Opsæt MutationObserver på URL-skift
    let lastUrl = location.href;
    new MutationObserver(() => {
      const url = location.href;
      if (url !== lastUrl) {
        lastUrl = url;
        const newVariant = getCurrentVariantId();
        if (newVariant && wrapper.hasAttribute('data-inventory-management')) {
          updateInformation('variant', newVariant);
        }
      }
    }).observe(document, { subtree: true, childList: true });

  } catch (err) {
    console.warn(err.message);
  }
})();